import React from 'react';
import PropTypes from 'prop-types';

function Gallery({ images, setActiveImage }) {
  if (images.length <= 1) return null;
  return (
    <div className="flex items-center mt-2 -ml-2 overflow-x-auto">
      {images.map((src, index) => (
        <Thumbnail
          key={index}
          src={src}
          onClick={() => setActiveImage(index)}
        />
      ))}
    </div>
  );
}

Gallery.propTypes = {
  images: PropTypes.array.isRequired,
  setActiveImage: PropTypes.func.isRequired,
};

function Thumbnail({ src, onClick }) {
  return (
    <div className="flex-shrink-0 w-1/3 pl-2">
      <div className="relative h-0 aspect-ratio-square">
        <button
          type="button"
          onClick={onClick}
          className="absolute inset-0 focus:z-10"
        >
          <img
            src={src.originalSrc}
            className="object-contain w-full h-full bg-gray-50"
            alt={src.altText}
          />
        </button>
      </div>
    </div>
  );
}

Thumbnail.propTypes = {
  onClick: PropTypes.func.isRequired,
  src: PropTypes.object.isRequired,
};

export { Gallery };
